import type { ContentSummary, PublicationSummary } from '@cms/contracts'
import type { ChipTone } from './primitives.js'
import type { IconName } from './icons.js'

export function contentStatusTone(status: ContentSummary['status']): ChipTone {
  return status
}

export function publicationTone(status: PublicationSummary['status']): ChipTone {
  return status === 'succeeded' ? 'success' : status === 'failed' ? 'error' : 'progress'
}

/** An icon per content type, for the lists; unknown types get a generic page. */
export function contentTypeIcon(key: string): IconName {
  if (/article|post|news|blog/i.test(key)) return 'article'
  if (/page|landing/i.test(key)) return 'web'
  return 'description'
}
